import { LodgingInputType } from '__generated__/api';

export const getInputType = (inputType: LodgingInputType): string => (inputType ? inputType.toLowerCase() : 'hidden');
